import React from 'react';
import { Text, View } from '@react-pdf/renderer';
import { usePdfStyles } from './PdfPrintScaleContext';

export function CompanyPdfHeader({ title, subtitle }) {
    const pdfStyles = usePdfStyles();
    return (
        <View style={pdfStyles.headerRow}>
            <View style={pdfStyles.brandBlock}>
                <Text style={pdfStyles.brandTitle}>Sicily Shopping To Malta Ltd</Text>
                <Text style={pdfStyles.brandLine}>Warehouse E 13, Midland Park</Text>
                <Text style={pdfStyles.brandLine}>Industrial Estate Naxxar, NXR 6345, Malta</Text>
                <Text style={pdfStyles.brandLine}>Tel: 99456742 / 77779991 · VAT: MT30397804</Text>
            </View>
            <View style={pdfStyles.metaBlock}>
                <Text style={pdfStyles.h1}>{title}</Text>
                {subtitle ? <Text style={pdfStyles.subtitle}>{subtitle}</Text> : null}
            </View>
        </View>
    );
}
